import { createLogger } from "@bigpp/log";
import { initBrowserLogger, copyDebugLog, getDebugLog, clearDebugLog } from "@bigpp/log/browser";

initBrowserLogger({ minLevel: "debug" });

export const log = createLogger("addin");
export { copyDebugLog, getDebugLog, clearDebugLog };
